var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "question",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.483,
    height: 27.627,
    viewBox: "0 0 27.483 27.627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M2775.938,3068.24a1.119,1.119,0,0,1-.961-1.692l2.88-4.828a13.276,13.276,0,0,1-2.414-7.678,13.432,13.432,0,1,1,6.774,11.663l-5.848,2.448A1.121,1.121,0,0,1,2775.938,3068.24Zm6.371-4.9a1.118,1.118,0,0,1,.6.173,11.205,11.205,0,1,0-2.827-2.549,1.119,1.119,0,0,1,.082,1.265l-1.523,2.553,3.238-1.356A1.119,1.119,0,0,1,2782.309,3063.336Z",
    transform: "translate(-2774.82 -3040.613)",
    fill: "#404149"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453",
    transform: "translate(9.738 6.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M2813.588,3074.99a3.909,3.909,0,0,1,.4-1.9,6.273,6.273,0,0,1,1.118-1.416,7.068,7.068,0,0,0,.947-1.01,1.75,1.75,0,0,0,.3-1.046,1.153,1.153,0,0,0-.388-.893,1.228,1.228,0,0,0-.839-.352,1.446,1.446,0,0,0-1.118.451,3.96,3.96,0,0,0-.721,1.208l-2.074-.974a4.745,4.745,0,0,1,.649-1.281,4.268,4.268,0,0,1,1.353-1.218,4.643,4.643,0,0,1,4.807.3,3.065,3.065,0,0,1,1.019,2.525,3.824,3.824,0,0,1-.37,1.84,4.706,4.706,0,0,1-.8,1.091q-.433.424-.559.55a4.763,4.763,0,0,0-.884,1.172,3.34,3.34,0,0,0-.307,1.533v.379h-2.525Zm.2,4.41a1.157,1.157,0,0,1-.415-.929,1.209,1.209,0,0,1,.424-.938,1.526,1.526,0,0,1,1.055-.379,1.459,1.459,0,0,1,1.037.379,1.231,1.231,0,0,1,.406.938,1.181,1.181,0,0,1-.4.929,1.519,1.519,0,0,1-1.046.352A1.587,1.587,0,0,1,2813.786,3079.4Z",
    transform: "translate(-2811.207 -3066.026)",
    fill: "#404149"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionDark);
export default __webpack_public_path__ + "static/media/question_dark.2d859a5fd89129c6a38a6e7fcf893695.svg";
export { ForwardRef as ReactComponent };